import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cc966be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "AppointList" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "상담 현황", -1))
const _hoisted_3 = { class: "table-search" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "hidden" }, "글 목록", -1))
const _hoisted_5 = { class: "table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "hidden" }, "분류", -1))
const _hoisted_7 = { class: "tr th" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<span class=\"col1 col-number\" data-v-1cc966be>No.</span><span class=\"col2\" data-v-1cc966be>상담 날짜</span><span class=\"col3\" data-v-1cc966be>상담 시간</span><span class=\"col4\" data-v-1cc966be>환자명</span><span class=\"col5\" data-v-1cc966be>의료진명</span>", 5)
const _hoisted_13 = { class: "col6" }
const _hoisted_14 = { class: "input-item select-status" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-title" }, "환자 요청", -1))
const _hoisted_16 = { class: "col7" }
const _hoisted_17 = { class: "input-item select-status" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-title" }, "의료진 응답", -1))
const _hoisted_19 = { class: "col8" }
const _hoisted_20 = { class: "input-item select-status" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-title" }, "상담 진행", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "hidden" }, "내용", -1))
const _hoisted_23 = {
  key: 0,
  class: "list-loading"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dots" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "msg" }, "조회중..", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "err-server"
}
const _hoisted_28 = { class: "err-server-msg" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "col1 col-number" }
const _hoisted_31 = { class: "col2" }
const _hoisted_32 = { class: "col3" }
const _hoisted_33 = { class: "col4 txt-wrap" }
const _hoisted_34 = { class: "col5 txt-wrap" }
const _hoisted_35 = { class: "col6" }
const _hoisted_36 = { class: "status-button-vue" }
const _hoisted_37 = { class: "col7" }
const _hoisted_38 = { class: "status-button-vue" }
const _hoisted_39 = { class: "col8" }
const _hoisted_40 = { class: "status-button-vue" }
const _hoisted_41 = { class: "page-nation-vue" }
const _hoisted_42 = {
  key: 0,
  class: "currentPopup"
}

import { onBeforeMount, onMounted, watch, ref, computed } from 'vue';
import { useStore } from 'vuex';
import BoardSearcher from '@/components/item/BoardSearcher.vue';
import AppointInfoPopup from '@/views/appoint/popup/AppointInfoPopup.vue';
import PageNation from '@/components/item/PageNation.vue';
import StatusButton from '@/components/button/StatusButton.vue';
import BoardState from '@/components/item/BoardState.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AppointList',
  setup(__props) {

const store = useStore();
const Appt = store.state.moduleAppt;
/**** data -------------------- */
var exception = computed(() => Appt.exception);
var appointList = computed(() => Appt.appointList);
var appointSid = ref();
var totalCount = computed(() => Appt.totalCount);
var propsPageNumber = ref(1);
var pageNumber = ref(1);
var lastPageNumber = computed(() => store.getters['moduleAppt/getLastPageNumber']);
var rowNumber = ref(8);
var periodEasy = ref('00');
var dateStart = ref('');
var dateEnd = ref('');
var searchType = ref('00');
var searchWord = ref('');
var patientAction = ref('');
var doctorState = ref('');
var appointState = ref('');
var searchTypes = ref([
  { code: '', name: '전체' },
  { code: '00', name: '환자명' },
  { code: '01', name: '의료진명' },
]);
var stateOptions_patient = ref([
  { code: '', name: '전체' },
  { code: '00', name: '요청' },
  { code: '01', name: '취소' },
]);
var stateOptions_doctor = ref([
  { code: '', name: '전체' },
  { code: '00', name: '미응답' },
  { code: '01', name: '확정' },
  { code: '02', name: '반려' },
]);
var stateOptions_appoint = ref([
  { code: '', name: '전체' },
  { code: 'wait', name: '대기' }, //03
  { code: 'confirm', name: '확정' }, //04
  { code: 'finished', name: '완료' }, //05
  { code: 'reject', name: '반려' }, //08
  { code: 'noanswer', name: '미응답' }, //99
  { code: 'noshow', name: '노쇼' }, //999
]);
var currentPatient = ref({});
var currentPopup = ref(null);
var isOnListLoading = ref(true);
var popupTitle = ref('');
var popupDesc = ref('');
var paramForList = ref({});
/**** methods ----------------- */
const setPeriodOption = (item: { code: string; name: string }) => {
  periodEasy.value = item.code;
};
const setDates = (start: string, end: string) => {
  // console.log(`검색: 시작일 ${start} ~ 종료일 ${end}`);
  dateStart.value = start; // yyyy-MM-dd
  dateEnd.value = end; // yyyy-MM-dd
};
const setSearchType = (item: { code: string; name: string }) => {
  //console.log('0');
  searchType.value = item.code;
};
const setSearchWord = (word: string) => {
  // console.log(`검색: 검색어 ${word}`);
  searchWord.value = word;
};
const setStateOption_patient = (item: { code: string; name: string }) => {
  patientAction.value = item.code;
};
const setStateOption_doctor = (item: { code: string; name: string }) => {
  doctorState.value = item.code;
};
const setStateOption_appoint = (item: { code: string; name: string }) => {
  appointState.value = item.code;
};
const onClick_searchButton = (word: string) => {
  searchWord.value = word;
  setAppointList(1);
};
const onClick_pageNumber = (num: number) => {
  pageNumber.value = num;
};
const onClick_close = () => {
  currentPopup.value = null;
};
const onClick_item = async (item, index) => {
  currentPatient.value = item;
  appointSid.value = item.bookingSid;
  currentPopup.value = AppointInfoPopup;
};
const setAppointList = async (pNum: number) => {
  pageNumber.value = pNum;
  isOnListLoading.value = true;
  paramForList.value = {
    page_index: pageNumber.value, // *
    page_rows: rowNumber.value, // *
    search_period: periodEasy.value,
    search_date_begin: dateStart.value,
    search_date_end: dateEnd.value,
    search_text: searchWord.value,
    search_type: searchType.value,
    patient_action: patientAction.value,
    physician_state: doctorState.value,
    state: appointState.value, // *
  };
  await store.dispatch('moduleAppt/getAppointList', paramForList.value, { root: true });
  setTimeout(() => {
    isOnListLoading.value = false;
  }, 800);
};
/**** content -----------------
 *
 * 상담 현황
 * /
 * /
/**** hook -------------------- */
onBeforeMount(() => {
  store.state.moduleAppt.appointList = [];
});
onMounted(() => {
  setAppointList(1);
});
watch(
  () => pageNumber.value,
  () => {
    setAppointList(pageNumber.value);
  },
  { deep: true }
);
watch(
  () => currentPopup.value,
  (newValue, oldValue) => {
    if (newValue === null) {
      setAppointList(pageNumber.value);
    }
  },
  { deep: true }
);
watch(
  () => patientAction.value,
  (newValue, oldValue) => {
    setAppointList(1);
  },
  { deep: true }
);
watch(
  () => doctorState.value,
  () => {
    setAppointList(1);
  },
  { deep: true }
);
watch(
  () => appointState.value,
  () => {
    setAppointList(1);
  },
  { deep: true }
);
watch(
  () => periodEasy.value,
  () => {
    setAppointList(1);
  },
  { deep: true }
);
watch(
  () => dateStart.value,
  () => {
    setAppointList(1);
  },
  { deep: true }
);
watch(
  () => dateEnd.value,
  () => {
    setAppointList(1);
  },
  { deep: true }
);
watch(
  () => pageNumber.value,
  () => {
    propsPageNumber.value = pageNumber.value;
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BoardSearcher, {
          "search-types": _unref(searchTypes),
          onSetPeriodOption: setPeriodOption,
          onSetDates: setDates,
          onSetSearchType: setSearchType,
          onSetSearchWord: setSearchWord,
          onOnClick_searchButton: onClick_searchButton
        }, null, 8, ["search-types"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(BoardState, {
                class: "bs-vue",
                "state-options": _unref(stateOptions_patient),
                onSetStateOption: setStateOption_patient
              }, null, 8, ["state-options"])
            ])
          ]),
          _createElementVNode("span", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(BoardState, {
                class: "bs-vue",
                "state-options": _unref(stateOptions_doctor),
                onSetStateOption: setStateOption_doctor
              }, null, 8, ["state-options"])
            ])
          ]),
          _createElementVNode("span", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(BoardState, {
                class: "bs-vue",
                "state-options": _unref(stateOptions_appoint),
                onSetStateOption: setStateOption_appoint
              }, null, 8, ["state-options"])
            ])
          ])
        ]),
        _hoisted_22,
        (_unref(isOnListLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
          : _createCommentVNode("", true),
        (!_unref(isOnListLoading) && _unref(exception).appointList.bool)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("p", {
                class: _normalizeClass([{ 'err-server-bang': _unref(exception).appointList.type === 'bang' }, { 'err-server-empty': _unref(exception).appointList.type === 'empty' }])
              }, null, 2),
              _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(exception).appointList.desc), 1)
            ]))
          : (!_unref(isOnListLoading) && !_unref(exception).appointList.bool)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(appointList), (item, index) => {
                return (_openBlock(), _createElementBlock("ul", {
                  class: "td",
                  key: item
                }, [
                  _createElementVNode("li", {
                    class: "tr",
                    onClick: _withModifiers(($event: any) => (onClick_item(item, index)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(totalCount) - _unref(rowNumber) * (_unref(pageNumber) - 1) - index), 1),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(item.appointDate), 1),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(item.appointTime), 1),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(item.patientName), 1),
                    _createElementVNode("span", _hoisted_34, _toDisplayString(item.doctorName), 1),
                    _createElementVNode("span", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(StatusButton, {
                          "status-name": item.patientState
                        }, null, 8, ["status-name"])
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(StatusButton, {
                          "status-name": item.doctorState
                        }, null, 8, ["status-name"])
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(StatusButton, {
                          "status-name": item.appointState
                        }, null, 8, ["status-name"])
                      ])
                    ])
                  ], 8, _hoisted_29)
                ]))
              }), 128))
            : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_41, [
        _createVNode(PageNation, {
          "props-page-number": _unref(propsPageNumber),
          "total-count": _unref(totalCount),
          "row-number": _unref(rowNumber),
          "last-page-number": _unref(lastPageNumber),
          onOnClick_pageNumber: onClick_pageNumber
        }, null, 8, ["props-page-number", "total-count", "row-number", "last-page-number"])
      ], 512), [
        [_vShow, !_unref(isOnListLoading) && !_unref(exception).appointList.bool]
      ])
    ]),
    _createVNode(_Transition, { name: "currentPopup" }, {
      default: _withCtx(() => [
        (_unref(currentPopup) !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentPopup)), {
                "popup-title": _unref(popupTitle),
                "popup-desc": _unref(popupDesc),
                "current-appoint": _unref(currentPatient),
                "appoint-sid": _unref(appointSid),
                onOnClick_close: onClick_close
              }, null, 40, ["popup-title", "popup-desc", "current-appoint", "appoint-sid"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})